/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
// import alert from 'react-s-alert';
import * as c from './constant';

export const getRegionList = (payload, callback) =>
  req.list(
    c.GET_REGION,
    '/api/v1/administrators/address/regions',
    payload,
    callback
  );

export const createRegion = (payload, callback) =>
  req.create(
    c.CREATE_REGION,
    'api/v1/administrators/line_businesses',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateRegion = (id, payload, callback) =>
  req.update(
    c.UPDATE_REGION,
    `api/v1/administrators/line_businesses/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeRegion = (id, payload, callback) =>
  req.remove(
    c.REMOVE_REGION,
    `api/v1/administrators/line_businesses/${id}`,
    payload,
    callback
  );

export const showRegion = (id, payload, callback) =>
  req.item(
    c.GET_SELECTED_REGION,
    `api/v1/administrators/address/regions/${id}`,
    payload,
    callback
  );

// nature business

export const getNatureBusinessList = (id, payload, callback) =>
  req.list(
    c.GET_NATURE_BUSINESS,
    `api/v1/administrators/line_businesses/${id}/nature_businesses`,
    payload,
    callback
  );

export const createNatureBusiness = (id, payload, callback) =>
  req.create(
    c.CREATE_NATURE_BUSINESS,
    `api/v1/administrators/line_businesses/${id}/nature_businesses`,
    payload,
    callback
  );

export const updateNatureBusiness = (id, naturebusinessId, payload, callback) =>
  req.update(
    c.UPDATE_NATURE_BUSINESS,
    `api/v1/administrators/line_businesses/${id}/nature_businesses/${naturebusinessId}`,
    payload,
    callback
  );

export const removeNatureBusiness = (id, naturebusinessId, payload, callback) =>
  req.remove(
    c.REMOVE_NATURE_BUSINESS,
    `api/v1/administrators/line_businesses/${id}/nature_businesses/${naturebusinessId}`,
    payload,
    callback
  );
